module.exports = __webpack_public_path__ + "static/RPF-ec9bd2e7b2711d80693572304550aaf9.png";